import React from 'react'

const Solid_2 = () => (
  <svg width="20" height="20" viewBox="0 0 25 23" xmlns="http://www.w3.org/2000/svg">
    <path d="M24.516 9.953C24.516 4.453 19.04 0 12.258 0 5.476 0 0 4.452 0 9.953c0 3.318 1.986 6.24 5.05 8.053-.34 2.552-1.815 4.055-1.844 4.084-.14.14-.17.368-.113.567a.524.524 0 0 0 .482.312c2.95 0 5.335-1.93 6.612-3.206.652.086 1.362.142 2.07.142 6.783 0 12.26-4.452 12.26-9.953z" fill="#7695a5" fill-rule="evenodd"/>
  </svg>
)
export default Solid_2


// WEBPACK FOOTER //
// ./src/layouts/CustomizeDrift/chat_solid_2.js